import About from 'components/services/commons/About'
import Assignment from 'components/services/commons/Assignment'
import Whyi3 from 'components/services/commons/Whyi3'
import CaseStudy from 'components/home/CaseStudy'
import styles from 'components/services/dx/Template.module.scss'
import Process from 'components/services/commons/Process'
import ServiceMainTitle from 'components/services/commons/ServiceMainTitle'
import { serviceMainTitle } from './TitleGroup'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'
const Dx: React.FC = () => {
  const paths = [
    { name: 'TOP', url: '/' },
    { name: 'Services', url: '#' },
    { name: 'DX戦略策定', url: '#' },
  ]
  const aboutList = [
    {
      text: 'DXを推進するには「新たなデジタル技術を活用して、どのようにビジネスや業務を変革していくか」という戦略そのものの解像度を高めることが必要不可欠です。',
    },
    {
      text: '現状を正しく理解し、あるべき姿を見定め、目標に到達するための行動策定と実行を見据え、業務効率化や生産性向上、顧客体験の向上などを実現しましょう。我々はクライアントの持続的な成長を支えるために、革新的なアプローチで伴走します。',
    },
  ]
  const assignmentList = [
    { title: '業務効率が向上しない', text: '業務プロセスを自動化し、従業員がより高度な業務に専念できるようにします。' },
    {
      title: '生産性が向上しない',
      text: 'ビッグデータや分析ツールを用いて、データドリブンな意思決定を促進し、生産性向上の支援をします。',
    },
    {
      title: '運用コストの削減の難易度が高い',
      text: 'インフラの見直し、クラウド技術の導入などを通じて運用コストを削減します。',
    },
    {
      title: '顧客体験を向上させる戦略が定まらない',
      text: 'オンラインでのサービス提供やパーソナライズなコミュニケーションを強化し、顧客体験を向上させるための戦略を提供します。',
    },
    {
      title: 'デジタルスキルが向上しない',
      text: '従業員に必要なデジタルスキルを向上させ、テクノロジーを適切に活用できるよう支援します。',
    },
  ]
  const reasonList = [
    {
      icon: '/images/icons/icon_understand.svg',
      title: '迅速な業務理解',
      text: '迅速な業務理解によってスピーディにプロジェクトを回すことができます。',
    },
    {
      icon: '/images/icons/icon_output.svg',
      title: '実際の運用を意識したアウトプット',
      text: '構想だけで終わらせない、その後の開発・運用などのアクティベーションを重視したアウトプットの提供。',
    },
    {
      icon: '/images/icons/icon_idea.svg',
      title: 'ソリューションアイデアの提供',
      text: '多くの戦略フレームワークを熟知し、ビジネスとテクノロジー、UIUXを総合的に理解した経験豊富なコンサルタントによるアドバイス。',
    },
  ]
  const processList = [
    {
      title: '現状分析・課題の可視化',
      term: '2~3ヶ月',
      text: '現在の事業や組織課題、組織の状況を網羅的にヒアリングして本質的な課題を特定し、目標とのGAPを可視化します。',
      deliverables: [{ link: '#', name: '要件整理（現状分析とあるべき姿のFitGap）' }],
    },
    {
      title: '解決ソリューションの検討',
      term: '6ヶ月',
      text: 'お客さまとディスカッションを繰り返しながら、解決するべき課題の解像度をあげます。その上で、適切なソリューションを考察検討いたします。',
      deliverables: [{ link: '#', name: 'PoC' }],
    },
    {
      title: '実行計画策定',
      term: '3ヶ月',
      text: 'ソリューション構想後、実行計画を策定し、PoC〜要件定義〜デザイン・設計〜開発〜運用まで一気通貫して支援いたします。',
      deliverables: [{ link: '#', name: '実装・運用' }],
    },
  ]
  return (
    <>
      <ServiceMainTitle serviceMainTitle={serviceMainTitle} paths={paths} />
      <About list={aboutList} />
      <Assignment list={assignmentList} />
      <div className={styles.colored}>
        <Whyi3 list={reasonList} />
      </div>
      <Process list={processList} isVisibleAnnotation />
      <CaseStudy />
      <div className={styles.linklist}>
        <MailmagazineLink />
      </div>
    </>
  )
}

export default Dx
